module.exports = __webpack_public_path__ + "static/media/magic-link-error.c28e97c6.svg";